import React from 'react';
import StaticPageHeader from '../components/common/StaticPageHeader';
import useMerchantSettings from '../hooks/useMerchantSettings';
import { errorView, loadingView } from '../utils/Utilities';
import { Helmet } from 'react-helmet-async';
import '../assets/css/allpages.css';

const ShippingPolicy = () => {
    const { merchantSettings, loading, error } = useMerchantSettings();
    const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    const storeName = merchantSettings?.legal_name || 'Online Store';

    return (
        <div className="static-page-wrapper">
            <Helmet>
                <title>{`Shipping Policy | ${storeName}`}</title>
                <meta name="description" content={`Read about shipping rates, domestic & international delivery times, and fulfillment policies at ${storeName}.`} />
                {currentOrigin && <link rel="canonical" href={`${currentOrigin}/shipping`} />}
            </Helmet>
            <StaticPageHeader title="Shipping Policy" />
            {loading ? loadingView() : error ? errorView(error) : (
                <div className="container static-page-container">
                    <div className="static-page-content">
                        <div dangerouslySetInnerHTML={{ __html: merchantSettings.merchant_configuration?.shipping_policy }} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default ShippingPolicy;